import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from '@tech-services/common.service';
import { SessionService } from '@tech-services/session.service';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-techmodalriskprofileexpire',
  templateUrl: './techmodalRiskProfileExpire.component.html',
  styleUrls: ['./techmodalRiskProfileExpire.component.scss'],
})
export class TechModalRiskProfileExpireComponent implements OnInit {
  public domain: string = AppConfig.settings.domain;
  public customTheme = localStorage.getItem('ThemeImg');

  constructor(
    public dialogRef: MatDialogRef<TechModalRiskProfileExpireComponent>,
    private common: CommonService,
    private router: Router,
    private session: SessionService // @Inject(MAT_DIALOG_DATA) public data: TechModalRiskProfileExpireModel
  ) {}

  ngOnInit() {}

  goOut(): void {
    this.dialogRef.close();
  }

  goToRetake() {
    this.common.showMenuSource.next(false);
    this.session.operativeInit = 'dashboard';
    this.router.navigate(['/riskprofile']);
    this.dialogRef.close();
  }
}
